export default __webpack_public_path__ + "static/media/15_photo.a68be113.jpeg";